// -------------- import external dependencies ------------
import styled from "styled-components";

export const BtnStyle = styled.button`
  min-height: ${({ variant }: { variant: string }) =>
    (variant === "sm" && "40px") || (variant === "md" && "50px")};
  min-width: 100px;
  border-radius: 5px;
  border: none;
  background: transparent;
  font-family: Inter;
  font-weight: 400;
  padding: 0.5rem 0.8rem;
  width: 100%;
  margin-right: 0.5rem;
  height: fit-content;
  height: 31px;
  cursor: pointer;
  @media screen and (min-width: 768px) {
    width: auto;
  }
  @media only screen and (max-width: 768px) {
    /* width: 50%; */
    margin-right: 0.5rem;
    /* margin: 0 auto; */
  }
  &:disabled {
    opacity: 0.5;
  }
`;
